'use strict';
import angular from 'angular';
import ngMessages from 'angular-messages';
import AddressController from './address.controller';
import AddressService from './address.service';
import ngMaterial from 'angular-material';
import CreditCardService from '../../../credit-card-list/credit-card.service';
export default angular.module('directives.addressForm', [ngMessages, ngMaterial])
    .service('CreditCardService', CreditCardService)
    .service('AddressService', AddressService)
    .component('addressForm', {
    template: require('./address.html'),
    controller: AddressController,
    bindings: {
        address: '<',
        updateForm: '<',
        createForm: '<',
        showRecipient: '<',
        showDefault: '<',
        disableCountry: '<',
        creditCard: '=',
        showUsOnly: '<',
        isBillingAddress: '<',
        manageShipping: '<',
        resetForm: '<',
        addressType: '<',
        changeAccountInfo: '<',
        manageCreditcard: '<',
        isDefaultCreditcard: '<',
        credentials: '=',
        rxConfig: '=',
        disableAddressForm: '<',
        isNewCreditCard: '=',
        paymentCreditCard: '=',
        isAddNewShippingAddress: '<'
    }
})
    .name;
//# sourceMappingURL=index.js.map